import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import Loader from "./Loader";
import Error from "./Error";

// HTML Articles
import WebWorking from "./html/WebWorking";
import AboutHTTP from "./html/AboutHttp";
import HTMLIntroduction from "./html/HTMLIntroduction";

function MainComponent({ subject }) {
  const article = useParams().article || "webworking";

  const [showLoader, setShowLoader] = useState(true);

  const closeLoader = () => {
    setShowLoader(false);
  };

  // console.log(subject, article);

  return (
    <>
      {showLoader && <Loader closeLoader={closeLoader} />}
      <Sidebar></Sidebar>
      <GetArticle subject={subject} article={article} />
    </>
  );
}

function GetArticle({ subject, article }) {
  if (subject === "html") {
    switch (article) {
      case "webworking":
        return <WebWorking></WebWorking>;
      case "about_HTTP":
        return <AboutHTTP />;
      case "HTML_introduction":
        return <HTMLIntroduction />;
      default:
        return <Error />;
    }
  } else {
    return <Error />;
  }
}

export default MainComponent;
